// Timezone formatting utilities for the app

/**
 * Interpret a backend timestamp as UTC and format it in IST (Asia/Kolkata).
 * Handles both full ISO strings and 'YYYY-MM-DD HH:MM:SS' without timezone.
 */
export const formatDateTimeIST = (value?: string | null): string => {
  if (!value) return '—';

  let iso = value.trim();

  // If backend sends 'YYYY-MM-DD HH:MM:SS' (no timezone) – treat as UTC
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(iso)) {
    iso = iso.replace(' ', 'T');
  }

  // If there's no timezone info (no Z, no +hh:mm / -hh:mm), assume UTC
  if (!/[zZ]$/.test(iso) && !/[+-]\d{2}:\d{2}$/.test(iso)) {
    iso += 'Z';
  }

  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';

  return d.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
};

